<template>
  <div class="phones-box">
    <div v-if="client.phones.length > 0">
      <div class="margin-right" v-for="(c, index) in client.phones" :key="c.id">
        <p
            class="contact contact-phone"
            v-if="index === 0"
            :class="{ 'primary-contact': c.is_primary }"
        >
          <span class="move-it-right">
            <a href="javascript:void(0)" @click="$emit('sms')">
              <img
                  class="smsImage"
                  width="17"
                  src="../../../../../assets/svg_icons/smsicon.png" />
              <span :class="{ 'fa-lg': c.is_primary }"></span
              ></a>
            <span
                class="phones-length non-bold"
                @mouseleave="showSMSsentTable = false"
                @mouseenter="showSMSsentTable = true"
                v-if="!expanded"
                href="javascript:void(0)"
            >
              {{ client.sms_log.length }}</span
            >
          </span>

          <!--          <a href="javascript:void(0)" @click="call(c.contact_value)"-->
          <!--            ><img-->
          <!--              width="15"-->
          <!--              src="../../../../../assets/svg_icons/call_ico.svg"/>-->
          <!--            <span :class="{ 'fa-lg': c.is_primary }"></span-->
          <!--          ></a>-->
          <span
              class="calls-length"
              v-if="!expanded"
              href="javascript:void(0)"
              @mouseenter="showLogTable = true"
              @mouseleave="showLogTable = false"
          >{{ client.calls_log.length }}
          </span>
          <span
              class="phone-number"
              @mouseover="showFullPhone = true"
              @mouseleave="showFullPhone = false"
          >&nbsp;{{ trimThePlus(c.contact_value) | truncate(12) }}</span
          >

          <!--          <span class="align-the-num-p">-->
          <!--            <span-->
          <!--              class="phones-length"-->
          <!--              @mouseleave="showTable = false"-->
          <!--              @mouseenter="showTable = true"-->
          <!--              v-if="!expanded && client.phones.length>0"-->
          <!--              href="javascript:void(0)"-->
          <!--              @click="$emit('edit')"-->
          <!--            >-->
          <!--              {{ client.phones.length }}-->
          <!--            </span>-->
          <!--          </span>-->

          <a
              class="aligenItRight"
              href="javascript:void(0)"
              @click="call(c.contact_value)"
          ><img
              class="forPhoneIcone"
              width="15"
              src="../../../../../assets/svg_icons/phoneicon.png" />
            <span :class="{ 'fa-lg': c.is_primary }"></span
            ></a>
          <span class="align-the-num-p" @click=onEditPhones>
            <span
                class="phones-length-for-phone"
                :style="!isValidPhone?'color:red':''"
                @mouseleave="showTable = false"
                @mouseenter="showTable = true"
                v-if="!expanded && client.phones.length > 0"
                href="javascript:void(0)"
            >
              {{ client.phones.length }}
            </span>
          </span>

          <!--          <span class="move-it-right">-->
          <!--&lt;!&ndash;            && client.sms_log.length>0&ndash;&gt;-->
          <!--            <span-->
          <!--              class="phones-length non-bold"-->
          <!--              @mouseleave="showSMSsentTable = false"-->
          <!--              @mouseenter="showSMSsentTable = true"-->
          <!--              v-if="!expanded "-->
          <!--              href="javascript:void(0)"-->
          <!--            >-->
          <!--              {{ client.sms_log.length }}</span-->
          <!--            >-->
          <!--            <a href="javascript:void(0)" @click="$emit('sms')">-->
          <!--              <img width="17" src="../../../../../assets/svg_icons/smsicon.png"/>-->
          <!--              <span :class="{ 'fa-lg': c.is_primary }"></span-->
          <!--            ></a>-->
          <!--          </span>-->
          <!--          <a-->
          <!--            class="aligenItRight"-->
          <!--            href="javascript:void(0)"-->
          <!--            @click="call(c.contact_value)"-->
          <!--            ><img-->
          <!--              width="15"-->
          <!--              src="../../../../../assets/svg_icons/phoneicon.png"/>-->
          <!--            <span :class="{ 'fa-lg': c.is_primary }"></span-->
          <!--          ></a>-->
        </p>
        <div v-if="showFullPhone" class="phone-popup">
          {{ c.contact_value }}
        </div>
      </div>
    </div>
    <div v-else>
      No-Phone
    </div>
    <div v-if="showTable" class="phones-table">
      <div class="table-responsive">
        <table class="table">
          <tbody>
          <tr v-for="(item, idx) in client.phones" :key="idx">
            <td>{{ item.is_primary == 1 ? "Primary" : "" }}</td>
            <td>{{ item.contact_value }}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div
        v-if="latestSms().length > 0 && showSMSsentTable"
        class="tag-table"
        @mouseenter="showSMSsentTable = false"
    >
      <div class="table-responsive">
        <table class="table">
          <tbody>
          <tr v-for="(sms, idx) in latestSms()" v-bind:key="idx">
            <td>{{ formatDate(sms.created_at) }}</td>
            <td>{{ sms.user ? sms.user.full_name : '' }}</td>
            <td>
              <strong>{{ sms.contact_value }}</strong>
            </td>
            <td>
              <strong>{{ sms.status }}</strong>
            </td>
            <td>{{ sms.preset ? sms.preset.preset:'' }}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div v-if="latestCalls().length > 0 && showLogTable" class="tag-table">
      <div class="table-responsive">
        <table class="table">
          <tbody>
          <tr v-for="(item, idx) in latestCalls()" :key="idx">
            <td>{{ formatDate(item.created_at) }}</td>
            <td>{{ item.user.full_name }}</td>
            <td>{{ item.phone_id }}</td>

            <!--              <td>how many times:</td>-->
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import { mapState, mapGetters } from "vuex";
import { Globals } from "../../../../../global_constants/constants";
import apiClientCreator from "../../../../../helpers/api/request";
import LoginView from "@/main/user.main/LoginView";

export default {
  name: "client-phones",

  props: {
    client: {
      type: Object
    }
  },
  computed: {
    ...mapState("user", ["auth"]),
    ...mapState("clients", ["dictionaries"])
  },

  created() {
    this.checkIfValidPhone();
  },
  data() {
    return {
      expanded: false,
      showTable: false,
      showLogTable: false,
      showSMSsentTable: false,
      callsLogArr: [],
      showFullPhone: false,
      isValidPhone: true,
      invalidNumbers:[]
    };
  },

  methods: {
    trimThePlus(val) {
      return val.replace("+", "");
    },
    checkIfValidPhone() {
      this.client.tech_logs.find(log => {
        if (log.asset === "PHONE_MALFORMED") {
          const invalidNumber = log.from;
          this.client.phones.find(phoneNumber => {
            if (phoneNumber.contact_value === invalidNumber){
               this.isValidPhone = false;
               this.invalidNumbers.push(phoneNumber.contact_value);
            }
          });
        }

      });
    },
onEditPhones(){
      this.$emit("edit")
  if(!this.isValidPhone) this.$emit("invalidPhones",this.invalidNumbers)
},
    latestCalls() {
      let tempCalls = this.client.calls_log.slice(0, 7);
      return tempCalls;
    },
    latestSms() {
      let tempSms = this.client.sms_log.slice(0, 7);
      return tempSms;
    },
    formatDate(date) {
      return moment(String(date)).format("HH:mm DD/MM/YY ");
    },
    async call(number) {
      this.$store.commit("main/setShowVikiMsg", {
        show: true,
        msg: "Calling:" + " " + number + "...",
        type: "CALL",
        op: { type: "SYSTEM" }
      });

      try {
        this.savePhoneLog(number);
        if (
            // this.auth.user.backup_voip_user !== null &&
            // this.auth.user.backup_voip_user !== false
            this.auth.user.backup_voip_enable &&
            this.auth.user.backup_voip_user !== null
        ) {
          // https://gnmmedia.odricall.com/custom/click2call?username=7540&number=972529371132&caller_id_number=0

          const backupUserName = this.auth.user.backup_voip_user;
          const phoneNumber = number.replace("+", ""); // remove the (+) from number, by VoIP provider instruction
          this.$store.commit("clients/setLoading", true);
          const res = await axios({
            url: `${Globals.backup_click_2_call_url}${backupUserName}&number=${phoneNumber}&caller_id_number=0`,
            method: "GET"
          });
          this.$store.commit("clients/setLoading", false);
        } else {
          const leg_a = this.auth.user.voip_user;
          const leg_b = number;
          this.$store.commit("clients/setLoading", true);
          const res = await axios({
            url: `${Globals.click_2_call_url}${leg_a}/${leg_b}/00`,
            method: "GET"
          });
        }
        this.$store.commit("clients/setLoading", false);
        this.$store.commit("main/setShowVikiMsg", {
          show: true,
          msg: "Calling:" + " " + number + "...",
          type: "DONE",
          op: { type: "SYSTEM" }
        });
      } catch (e) {
        /*        this.$store.commit("main/setShowVikiMsg", {
                      show: true,
                      msg: "Dial Error!" + " " + " Error Status: " + e,
                      type: "ERROR"
                    });*/
        this.$store.commit("clients/setLoading", false);
      }
    },

    savePhoneLog(number) {
      let lastCallId = null;

      if (this.client.scheduled_calls.length > 0) {
        lastCallId = this.client.scheduled_calls[0].id;
      }

      const callDetails = apiClientCreator(`client/callslog/${this.client.id}`);
      callDetails
          .post("", {
            ca_rec_id: lastCallId,
            phone_id: number
          })
          .then(res => {
          });
    }
    /*    async sms(number) {
              this.$store.commit("main/setShowVikiMsg", {
                show: true,
                msg: "Sending SMS:" + " " + number + "...",
                type: "INFO"
              });

              try {
                const user_name = "romandulman";
                const password = "159753159753";
                const ani = "Info";
                const dnis = "+972529371132"; //"+380960600179";
                const msg = "T-REX CRM";

                this.$store.commit("clients/setLoading", true);
                const res = await axios({
                  url: `http://sms.commpeak.com:8001/api?username=${user_name}&password=${password}&ani=${ani}&dnis=${dnis}&message=${msg}&command=submit`,
                  method: "GET"
                });

                this.$store.commit("clients/setLoading", false);

                this.$store.commit("main/setShowVikiMsg", {
                  show: true,
                  msg: "SMS Sending success " + res.status,
                  type: "DONE"
                });
              } catch (e) {
                this.$store.commit("main/setShowVikiMsg", {
                  show: true,
                  msg: "SMS Sending Error!" + " " + " Error Status: " + e,
                  type: "ERROR"
                });
                this.$store.commit("clients/setLoading", false);
              }
            }*/
  }
};
</script>

<style scoped>
html * {
  font-family: "Montserrat" !important;
  font-size: 13px;
}

.phones-box {
  min-width: 110px;
  position: relative;
  /*box-shadow: inset 1px 1px 5px 3px #00000010;*/
  /*min-height: 27px;*/
  /*padding-right: 7px;*/
  /*padding-left: 7px;*/
  /*padding-top: 3px;*/
}

.phone-number {
  /*font-size: 11px;*/
  margin-left: 16%;
}

.phones-length-for-phone {
  /*font-size: 9px;*/
  /*cursor: pointer;*/
  /*font-weight: 700;*/
  /*justify-items: left !important;*/
  /*margin-right: 4px;*/
  color: #47d847;

  top: 1px;
  font-size: 9px;
  cursor: pointer;
  /*font-weight: 700;*/
  /* justify-items: right !important; */
  /* margin-right: 5px; */
  /*color: #279142;*/
  position: absolute;
  right: 28px;
}

.red {
  color: red;
}

.calls-length {
  font-size: 9px;
  color: #3d93d0;
  cursor: pointer;
  font-weight: 400;
  left: 46px;
  position: absolute;
}

.phones-table {
  position: absolute;
  top: 24px;
  right: 35px;
  z-index: 10001;
  width: max-content;
  margin-bottom: 0px;
  background-color: #fff;
  border-radius: 5px;
  border: solid 1px #4d4f50;

  font-family: Montserrat;
}

.table-responsive {
  margin-bottom: -18px;
  border-radius: 5px;
}

.tag-table {
  position: absolute;
  top: 20px;
  /*left: 170px;*/
  z-index: 10001;
  background-color: #fff;
  width: -webkit-max-content;
  width: -moz-max-content;
  width: max-content;
  font-size: 12px;
  font-weight: 400;
  border: solid 1px #4d4f50;
  /*position: absolute;*/
  /*top: 24px;*/
  /*left: 0;*/
  /*z-index: 10001;*/
  /*background-color: #fff;*/
  /*width: max-content;*/
  /*border: solid 1px #90a4ae;*/
  border-radius: 5px;
  /*-webkit-box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);*/
  /*-moz-box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);*/
  /*box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);*/
}

.phones-box div p span {
  font-size: 13px;
}

.move-it-right {
  /*margin-right: -26px;*/
}

.margin-right {
  margin-left: 0px;
}

.non-bold {
  font-weight: 400;
  color: #dd5cc1;
}

.align-the-num-p {
  margin-left: 3%;
}

.aligenItRight {
  position: absolute;
  right: 5px;
}

.phones-length {
  margin-right: -12px;
}

.smsImage {
  margin-left: 4%;
  transition: 0.5s ease-in-out;
}

.smsImage:hover {
  transform: scale(1.1);
  transition: 0.5s ease-in-out;
}

.forPhoneIcone:hover {
  transform: scale(1.1);
  transition: 0.5s ease-in-out;
}

.forPhoneIcone {
  transition: 0.5s ease-in-out;
}

.phone-popup {
  position: absolute;
  padding: 8px;
  top: 20px;
  left: 63px;
  z-index: 10001;
  border-radius: 5px;
  background-color: #fff;
  border: solid 1px #4d4f50;
  font-family: Montserrat;
  width: -webkit-max-content;
  width: -moz-max-content;
  width: max-content;
}

.contact-phone {
  cursor: pointer;
}
</style>
